<template>
  <div>

    <div class="loader" v-show="!isReady">
      <div class="loader-logo-container">
        <img v-show="loadw > -1" class="loader-logo" :src="'static/img/common/logo_white.png'" />
        <div class="load-bar" :style=" { 'width': loadw + '%' } "></div>
      </div> 
    </div>
    
    <div id="app" v-show="isReady">
      <navbar />

      <transition name="fade" mode="out-in">
        <router-view id="my-router-view" v-bind:class=" { active: isActive } "></router-view>
      </transition>
      
      <footbar />
      
      <div id="rotate-warning">
        <div id="rotate-container">
          <div id="rotate-sprite"></div>
          <h3>Please rotate your device</h3>
        </div>
      </div>

    </div>

    <!-- <div class="border border-top"></div>
    <div class="border border-bottom"></div>
    <div class="border border-left"></div>
    <div class="border border-right"></div> -->
  </div>
</template>

<script>
import footbar from './components/Footbar.vue'
import navbar from './components/Navbar.vue'
import {commontools} from './mixins/Styling'

export default {
  name: 'app',
  mixins: [commontools],
  data: function () {
    return {
      isActive: true,
      isReady: false,
      loadCounter: 0,
      loadw: -1
    }
  },
  methods: {
    loadImages () {
      this.isReady = true;
    }
  },
  mounted: function () {
    if (!('ontouchstart' in document.documentElement)) {
      document.documentElement.className += ' no-touch-device'
    } else {
      document.documentElement.className += ' touch-device'
    }
    this.loadImages()
  },
  components: { footbar, navbar }
}

</script>

<style>

@import '../static/css/vars.css';
@import '../static/css/custom.css';

.myfade-enter {
  opacity: 0;
}
.myfade-enter-to {
  opacity: 1
}
.myfade-enter-active {
  transition: all 1s ease;
}
.fade-enter {
    opacity: 0;
}
.fade-enter-active {
    transition: opacity 0.6s ease;
}
.fade-leave-active {
    transition: opacity 0.6s ease;
    opacity: 0;
}
.slither-enter-active, .slither-leave-active {
  transition: transform 1s;
}
.slither-enter, .slither-leave-to {
  transform: translateX(-100%);
}
.slither-enter-to, .slither-leave {
  transform: translateX(0);
}

</style>
